export enum OBJECT_TYPES {
	block = 'block',
	inline = 'inline',
	text = 'text',
	mark = 'mark',
}

export enum BLOCK_TYPES {
	p = 'paragraph',
	h1 = 'heading1',
	h2 = 'heading2',
	h3 = 'heading3',
	h4 = 'heading4',
	h5 = 'heading5',
	h6 = 'heading6',
}

export enum INLINE_TYPES {
	a = 'link',
}

export enum STYLE_TYPES {
	UNEDITABLE_STYLES = 'uneditableStyles',
	FONT_SIZE = 'font-size',
	FONT_FAMILY = 'font-family',
	FONT_WEIGHT = 'font-weight',
	FONT_STYLE = 'font-style',
	COLOR = 'color',
	TEXT_DECORATION = 'text-decoration',
	LETTER_SPACING = 'letter-spacing',
}

// We have to keep order of marks for proper display of formatted text (for example, color of underline)
export const MARK_TYPES = new Map<STYLE_TYPES, STYLE_TYPES>([
	[STYLE_TYPES.UNEDITABLE_STYLES, STYLE_TYPES.UNEDITABLE_STYLES],
	[STYLE_TYPES.FONT_SIZE, STYLE_TYPES.FONT_SIZE],
	[STYLE_TYPES.FONT_FAMILY, STYLE_TYPES.FONT_FAMILY],
	[STYLE_TYPES.FONT_WEIGHT, STYLE_TYPES.FONT_WEIGHT],
	[STYLE_TYPES.FONT_STYLE, STYLE_TYPES.FONT_STYLE],
	[STYLE_TYPES.COLOR, STYLE_TYPES.COLOR],
	[STYLE_TYPES.TEXT_DECORATION, STYLE_TYPES.TEXT_DECORATION],
	[STYLE_TYPES.LETTER_SPACING, STYLE_TYPES.LETTER_SPACING],
]);

export enum MARK_TAGS {
	span = 'span',
}

export enum TEXT_ALIGN {
	LEFT = 'left',
	CENTER = 'center',
	RIGHT = 'right',
	JUSTIFY = 'justify',
}

export const BLOCK_AND_INLINE_TAGS = {
	p: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.p,
	},
	h1: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.h1,
	},
	h2: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.h2,
	},
	h3: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.h3,
	},
	h4: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.h4,
	},
	h5: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.h5,
	},
	h6: {
		object: OBJECT_TYPES.block,
		type: BLOCK_TYPES.h6,
	},
	a: {
		object: OBJECT_TYPES.inline,
		type: INLINE_TYPES.a,
	},
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/RichTextEditor/helpers/constants.ts